import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import {
    excelDownloadStyles,
  useDialogPaperPropsRootStyle,
  usePublishRouteDialogStyle,
  rootSectionWithContainer,
  tagStyles,
  chipContainerStyles,
} from "SharedComponent/styles/sharedStyles";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";

export const useStyles = makeStyles((theme: Theme) => {
  const {
    publishDialogContentContainer,
    publishDialogPaperPropsRoot,
    deleteDialogPaperPropsRoot,
    hubSelectionDialogPaperPropsRoot,
  } = useDialogPaperPropsRootStyle(theme);

  const {
    hubSelectionDialogTitle,
    hubSelectionDialogContentContainer,
    publishDialogButtonsContainer,
    deleteDialogButtonsContainer,
    hubSelectionDialogButtonsContainer,
    deleteDialogContentContainer,
    publishErrorPopupContainer,
  } = usePublishRouteDialogStyle(theme);

  const {
    excelDownloadStatus,
    excelDownloadStatusText,
    checkedIconStyle,
    close,
    closeIcon,
    excelDownloadError,
    button,
    colSettings,
    buttonContainer,
  } = excelDownloadStyles(theme);

  return createStyles({
    ...rootSectionWithContainer(theme),
    tabPanelContainer: {
      flexDirection: "column",
      height: "100%",
      "& .panelItem": {
        width: "100%",
        "&.chipFilter": {
          padding: "16px 16px 16px 0px",
          "& .chipsContainer": {
            justifyContent: "space-between",
            "& .chipFilterItem": {
              height: 36,
              minWidth: "13%",
              borderRadius: theme.spacing(1),
              border: "1px solid rgba(10, 67, 124, 0.2)",
              backgroundColor: "#FFFFFF",
              cursor: "pointer",
              "&:last-child": {
                marginRight: 0,
              },
              "&.firstItem": {
                boxShadow: `0px 0px 10px 4px ${COLORS.BOX_SHADOW_PRIMARY}`,
                border: `2px solid ${theme.palette.primary.main}`,
              },
              "&.active": {
                background: `linear-gradient(274.11deg, ${COLORS.GRADIENT_BLUE} 2.78%, ${theme.palette.primary.main} 94.36%)`,
                border: "none",
                boxShadow: "none",
                "& .chipItem p": {
                  color: COLORS.WHITE,
                },
              },
              ...chipContainerStyles(theme)
            },
          },
        },
        "&.gridWrapper": {
          height: "calc(100% - 98px)",
          "& .idLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
          },
        },
      },
    },
    publishDialogContentContainer,
    publishDialogPaperPropsRoot,
    deleteDialogPaperPropsRoot,
    hubSelectionDialogPaperPropsRoot,
    hubSelectionDialogTitle,
    hubSelectionDialogContentContainer,
    publishDialogButtonsContainer,
    deleteDialogButtonsContainer,
    hubSelectionDialogButtonsContainer,
    deleteDialogContentContainer,
    publishErrorPopupContainer,
    actionsHeader: {
      alignItems: "center",
      "& .actionItem": {
        cursor: "pointer",
        "& .icon": {
          padding: theme.spacing(0.25),
          "&.editIcon": {
            marginRight: theme.spacing(0.75),
          },
        },
      },
    },
    deliveryAreaHeader: {
      alignItems: "center",
      "& .columnValue": {
        fontSize: 12,
      },
    },
    statusHeaderContainer: {
      "& .tag": {
        ...tagStyles(theme).base,
        ...useColorStyles(theme),
      },
    },
    excelDownloadStatus,
    excelDownloadStatusText,
    checkedIconStyle,
    close,
    closeIcon,
    excelDownloadError,
    button,
    colSettings,
    buttonContainer,
  });
});
